// extracted by mini-css-extract-plugin
export default {"editButton":"styles_editButton__Ek-bv","hideEditButton":"styles_hideEditButton__xXaud"};